import type { FieldValues } from 'react-hook-form';

/** Form values reached by a dynamic path are typed as a union; only strings are rendered in inputs. */
export const fieldText = (value: unknown): string => (typeof value === 'string' ? value : '');

/**
 * Banner-shaped fields (media, copy, buttons) live at `items.<n>` in a banner form and at
 * `header` in a rail form. Components that render them take the path as a string and read the
 * form through this loose shape; the editors that own the paths stay fully typed. Values read
 * this way only ever reach `fieldText` or an explicit cast.
 */
export type LooseForm = FieldValues;
